// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import {getAuth} from "firebase/auth"
import {getFirestore} from "firebase/firestore"
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBkaFDf-v62c4y1H6puEw7mWp2TQxrr4mU",
  authDomain: "cinemana-movies.firebaseapp.com",
  projectId: "cinemana-movies",
  storageBucket: "cinemana-movies.appspot.com",
  messagingSenderId: "274767155110",
  appId: "1:274767155110:web:b4e6c8c8113c9535444967",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);